import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);
window.Alpine = Alpine;

// Defer Alpine start until the DOM is ready. Guarded so it runs EXACTLY ONCE even if
// this script is evaluated again — under Turbo (case-center) the runtime lives in a
// data-turbo-permanent region so it isn't re-run, but this is cheap defense-in-depth.
function startAlpineOnce() {
    if (window.__alpineStarted) return;
    window.__alpineStarted = true;
    Alpine.start();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAlpineOnce);
} else {
    startAlpineOnce();
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
